// extracted by mini-css-extract-plugin
module.exports = {"sendResponse":"styles__sendResponse___2KeaB","sendResponseFooter":"styles__sendResponseFooter___gveLz styles__sendResponse___2KeaB"};